<script>
  import CommentTemplateClient from "./CommentTemplateClient.svelte";
  import CommentTemplateDev from "./CommentTemplateDev.svelte";
  import { onMount, onDestroy } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { user } from "../../firebase";
  import { baseAPIUrl } from "../../globals";
  import { router } from "tinro";
  import { serverTimestamp } from "firebase/firestore";
  import { Utils } from "../../utils";
  export let userTasks;
  import { authenticatedFetch } from "../../appbridge";
  import FileUpload from "../../components/FileUpload.svelte";
  import { conversion, lang } from "../../store/store";

  export let TaskRef;
  console.log(TaskRef);
  let userinfo;
  const { doc } = $user;
  userinfo = doc;
  let messageInfo;
  const dispatch = createEventDispatcher();

  console.log("------------------------------------------------------------");
  console.log(userTasks);
  console.log(userTasks.messages);
  console.log(Object.entries(userTasks.messages));

  let files = [];

  function handleAttachment(event) {
    files = [...files, ...event.target.files];
    console.log(files);
    return;
  }

  let attachments = [];

  function callbackFunction(event) {
    console.log("I'm here");
    attachments = [...attachments, event.detail];
    console.log(attachments);
  }

  let tempmessages = [];
  let showMessages = [];

  (async () => {
    console.log(userTasks.unread);
    if (userTasks.unread) {
      await $user.create.uptask({ unread: false }, TaskRef);
    }
  })();

  $: {
    tempmessages = Object.entries(userTasks.messages);
    tempmessages.sort((a, b) => a[1].timestamp - b[1].timestamp);
    showMessages = JSON.parse(JSON.stringify(tempmessages));
  }

  let value = "";
  let didAttach = false;

  async function AddElement(instanceValue, tempattach) {
    if (tempattach && [0, 1].includes(instanceValue.length)) {
      instanceValue = " \n";
    }
    if (instanceValue.length == 1) {
    }
    attachments = [];
    value = "";
    files = [];
    let date = new Date();

    date = date.getTime();

    showMessages = [
      ...showMessages,
      [
        "temp",
        {
          username:
            $userinfo.account.firstname + " " + $userinfo.account.lastname,
          comment_text: instanceValue,
          attachment: tempattach,
          role: "client",
          timestamp: date,
        },
      ],
    ];
    let attachlink = instanceValue;
    tempattach.forEach((element) => {
      attachlink =
        attachlink +
        "\n" +
        Utils.file.tokenToLink(
          `stores/${$user.auth.claims.store}/${element.name}`,
          element.token
        );
    });
    console.log(attachlink);
    let rep = await authenticatedFetch(baseAPIUrl + "/clickup/createComment", {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        comment_text: attachlink,
        taskid: userTasks.taskid,
      }),
    });

    rep = await rep.json();

    messageInfo = {
      username: $userinfo.account.firstname + " " + $userinfo.account.lastname,
      comment_text: instanceValue,
      attachment: tempattach,
      role: "client",
      comment_id: rep.commentid,
      timestamp: rep.date,
    };

    let unique = date + "-" + Utils.nanoid(); // to make
    let firebaseAttachments = userTasks.attachements;
    tempattach.forEach((element) => {
      firebaseAttachments["attachement-" + rep.date] = {
        date: String(rep.date),
        from: "firebase",
        name: element.name,
        token: element.token,
        type: element.type,
      };
    });
    let sendAttachments = {};

    console.log("HERE");
    console.log("HERE");
    console.log("HERE");

    console.log(sendAttachments);
    console.log("HERE");
    console.log("HERE");
    console.log("HERE");
    let messages = userTasks.messages;
    messages[unique] = messageInfo;
    if (firebaseAttachments.length != 0) {
      await $user.create.uptask(
        { ["attachements"]: firebaseAttachments, messages },
        TaskRef
      );
    } else {
      await $user.create.uptask({ messages }, TaskRef);
    }
    console.log(userTasks);
  }

  let tempattach = [];
  let state = true;
  const onKeyPress = (e) => {
    if (e.charCode === 13 && !e.shiftKey) {
      e.preventDefault();
      let test = value.split("\n");
      console.log(value);
      let tempvalue = value;
      tempattach = attachments;

      value = "";
      value.replace(/\n/g, "");
      attachments = [];
      files = [];
      AddElement(tempvalue, tempattach);
      return false;
    }
    return false;
  };

  $: {
    console.log(showMessages);
  }
</script>

{#if userTasks}
  <div class="CommentsContent">
    {#each showMessages as [id, message]}
      {#if message.role == "client"}
        <CommentTemplateClient obj={message} />
      {:else}
        <CommentTemplateDev obj={message} />
      {/if}
    {/each}
    {#if Object.entries(showMessages).length == 0}
      <div class="message-container">
        <div>{$conversion[$lang].chatMessages.message1}</div>
        <div>{$conversion[$lang].chatMessages.message2}</div>
      </div>
    {/if}
  </div>

  <div class="footerWrapper">
    <div class="footerContent">
      <div class="row">
        <div class="icon1Wrapper">
          <label class="input-attach-label" for="input">
            <input
              style="visibility:hidden"
              on:change={handleAttachment}
              id="input"
              class="attach"
              type="file"
            />
            <img class="attachment-img" src="../images/attach.svg" alt="" />
          </label>
        </div>

        <div class="textInput">
          <textarea
            bind:value
            type="text"
            placeholder={$conversion[$lang].SingleTask.TaskComments.placeholder}
            on:keypress={onKeyPress}
            class="message-area"
          />
        </div>
        <div class="icon4Wrapper"><i class="bx bx-smile" /></div>
        <div class="icon5Wrapper" on:click={AddElement(value, attachments)}>
          <img src="../images/white.svg" alt="" />
        </div>
      </div>
      {#if files.length > 0}
        <div class="attach-preview">
          {#each files as file}
            <FileUpload on:confirm={callbackFunction} {file} />
          {/each}
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  * {
    padding: 0;
    margin: 0;
  }

  ::-webkit-scrollbar {
    height: 3.5px;
    width: 3px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
  }

  .contentWrapper {
    background: red;
    padding: 1rem;
  }

  .headerDate {
    /* background: red; */
    display: flex;
    justify-content: center;
    /* height: 5%; */
    padding-top: 1rem;
  }

  .message-area {
    border: none;
    color: #7d8592;
    font-size: 0.8em;
    width: 100%;
    padding: 0.3rem;
    resize: none;
    height: 30px;
    max-height: 300px;
    outline: none;
  }

  .headerDate h5 {
    border: 1px solid #e6ebf5;
    color: #7d8592;
    font-weight: 400;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 20px;
  }

  .footerWrapper {
  }

  .CommentsContent {
    /* background-color: blue; */
    max-height: 500px;
    min-height: 450px;
    padding: 1rem 2rem;
    overflow-x: hidden;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .attach-preview {
    border-top: 1px solid #d8e0f0;
    margin-top: 0.4rem;
    display: flex;
    width: 100%;
    padding-top: 0.7rem;
  }

  .footerWrapper {
    align-items: flex-end;
    /* background-color: green; */
    /* height: 10%; */
    padding: 0.5rem;
  }

  .footerContent {
    /* display: flex; */
    /* flex-direction: column; */
    background: white;
    /* align-items: center; */
    border: 1px solid #d8e0f0;
    border-radius: 8px;
    padding: 0.5rem;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .icon1Wrapper,
  .icon2Wrapper,
  .icon3Wrapper,
  .icon4Wrapper,
  .icon5Wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 8%;
    height: 100%;
    color: #2c8f73;
    padding: 0.5rem;
    cursor: pointer;
  }

  .icon4Wrapper {
    color: #fdc748;
  }

  .message-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    color: #5f6368;
  }

  .icon5Wrapper {
    background-color: #2c8f73;
    color: white;
    border-radius: 12px;
    max-width: 2.6875rem;
    width: 100%;
  }

  .footerContent i {
    font-size: 1.5em;
  }

  .textInput {
    width: 76%;
    display: flex;
  }

  .textInput input {
    border: none;
    color: #7d8592;
    font-size: 0.8em;
    width: 100%;
  }

  /* .footerContent {
        border: 1px solid #d8e0f0;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .footerWrapper {
        padding-left: 2rem;
        padding-right: 2rem;
    } */

  .textInput input:focus {
    outline: none;
  }

  .textInput input {
    padding: 0.3rem;
    font-size: 0.8em;
  }

  .icon5Wrapper {
    box-shadow: 0px 6px 12px 0px #3f8cff43;
  }

  .attachment-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .input-attach-label {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
</style>
